const errorFields = () => {
  const errorFields = document.querySelectorAll('input.error, select.error, textarea.error')

  errorFields.forEach(field => {
    field.addEventListener('focus', () => {
      const parent = field.closest('.input-field')

      field.classList.remove('error')
      parent.classList.remove('error')
      parent.querySelector('.i-error').remove()
      parent.nextElementSibling.remove()
    })
  })

}

const formsHack = () => {
  errorFields()
}
export default formsHack
